import React, { useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import './PhotoManager.sass'
import { concat, isEmpty, cloneDeep } from 'lodash'
import arrayMove from 'array-move'
import PhotoTile from './PhotoTile'
import promiseAllValues from '../../utils/promiseAllValues'
import SortableList from '../../ui/SortableList/SortableList'
import { photoObject, deletePhoto, setAvatar } from './functions'
import useCallbacks from '../../hooks/useCallbacks'
import { base64ToFile } from '../../utils/files/base64ToFile'
import useModuleInit from '../../utils/newforms/changed/useModuleInit'

function PhotoManager({ projectId, projectPath, formData, syncState }) {
  const [photos, setPhotos] = useModuleInit({ formData, initialState: [] })

  useEffect(() => {
    syncState(photos)
  }, [photos])

  const handlers = useCallbacks((callbacks) => {
    callbacks.onDrop = (acceptedFiles) => {
      Promise.all(
        acceptedFiles.map((f, i) =>
          promiseAllValues(
            new photoObject({
              file: f,
              isAvatar: !!(i === 0 && isEmpty(photos)),
            })
          )
        )
      ).then((photoObjects) => setPhotos(concat(photos, photoObjects)))
    }
  })

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handlers.onDrop,
  })

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newPhotos = arrayMove(photos, oldIndex, newIndex)
    setPhotos(newPhotos)
  }

  return (
    <div
      className="PhotoManager"
      // style={!isEmpty(photos) ? { gridTemplateRows: 'max-content 1fr' } : {}}
    >
      {!isEmpty(photos) && (
        <SortableList
          className="PhotoManager-PhotoGrid"
          axis="xy"
          onSortEnd={onSortEnd}
          pressDelay={200}
          items={photos.map((p, i) => (
            <PhotoTile
              key={`photoTile-${i}`}
              {...p}
              setAvatar={() => setAvatar({ photoIndex: i, photos, setPhotos })}
              onDelete={() =>
                deletePhoto({
                  photoIndex: i,
                  photos,
                  setPhotos,
                  projectId,
                  docPath: projectPath,
                })
              }
            />
          ))}
        />
      )}
      <div className={['DragAndDrop-Zone'].join(' ')} {...getRootProps()}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Перетятине фото в это поле...</p>
        ) : (
          <p>
            Перетягніть декілька фото з комп'ютера, або <span>нажміть тут</span>{' '}
            для вибору фото вручну
          </p>
        )}
      </div>
    </div>
  )
}

export default PhotoManager
